import { FlexRow } from "@similarweb/ui-components";

import { InfoTooltip } from "app/components/React/Tooltip/InfoTooltip/InfoTooltip";
import { translate } from "app/filters/i18nFilter";

import { SectionTitle, InfoIconContainer } from "../../Settings/GeneralSettings/styles";

type TextWithInfoTooltipSchema = {
    tooltip: string;
    title: string;
    marginBottom?: number;
    iconColor?: string;
    dataAutomation?: string;
};

export const TextWithInfoTooltip = ({
    tooltip,
    title,
    marginBottom = 0,
    iconColor,
    dataAutomation,
}: TextWithInfoTooltipSchema) => (
    <FlexRow data-automation={dataAutomation}>
        <SectionTitle marginBottom={marginBottom}>{translate(title)}</SectionTitle>
        <InfoTooltip
            infoText={translate(tooltip)}
            infoIconContainer={InfoIconContainer}
            iconColor={iconColor}
        />
    </FlexRow>
);
